export default [
    {
        label: 'trips',
    },
    {
        label: 'trend',
    },
    {
        label: 'demography',
    },
    {
        label: 'traffic',
    },
    {
        label: 'zoom_service',
    },
    {
        label: 'transport',
    },
    {
        label: 'availibility',
    },
    {
        label: 'operational_cost',
    },
]